import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Breadcrumbs } from '@mui/material';
import { reset } from 'redux-form';
import ServiceProviderForm from '../ServiceProviderForm';
import { serviceProviderForm } from '../../Services/Utils/ServiceProviderApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { uploadImages } from '../../Services/Utils/CommonApis';

function AddServiceProvider() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [file, setFile] = useState([]);
  const [logoImage, setLogoImage] = useState([]);

  const [uploadResponses, setUploadResponses] = useState([]);

  let logoId = '';

  const handleFileChange = ({ fileList: newFileList }) => setFile(newFileList);

  function getFields(input, field) {
    let output = null;
    for (let i = 0; i < input.length; ++i) output = input[i][field];
    return output;
  }

  const handleChangeLogo = ({ fileList: newFileList }) => {
    setLogoImage(newFileList);
  };

  const fileUpload = async (imageFile, type) => (
    new Promise((resolve) => {
      const imageData = getFields(imageFile, 'originFileObj');
      uploadImages({ file: imageData }).then((res) => {
        uploadResponses.push({
          file: res,
          type,
        });
        resolve(res);
      });
    })
  );

  const onButtonClick = async (formData) => {
    const ProductGuide = [];
    const promises = [fileUpload(logoImage, 'logo')];
    productGuides.forEach((guide) => {
      if (guide.type === 'link') {
        ProductGuide.push({
          linkUrl: guide.data,
          type: guide.type,
        });
      } else {
        promises.push(fileUpload(guide.data, 'product-guide'));
      }
    });

    Promise.all(promises).then(async () => {
      uploadResponses.forEach(async (response) => {
        if (response.type === 'logo') {
          logoId = response.file.view.fileId;
        } else {
          ProductGuide.push({
            fileView: {
              fileId: response.file.view.fileId,
            },
            type: 'file',
          });
        }
      });

      const serviceProviderFinalData = {
        categoryView: {
          id: formData.serviceCategory.id,
        },
        logoView: {
          fileId: logoId,
        },
        serviceProviderFileViews: ProductGuide,
        name: formData.serviceprovidername,
        estimatedPerks: formData.estimatedValue,
        website: formData.websiteURL,
        brief: formData.briefIntroduction,
        dealDetails: formData.dealDetail,
        redemptionProcess: formData.dealRedemptionProcess,
        redemptionLink: formData.dealRedemptionLink,
        eligibility: formData.eligibilityCriteria,
        remarks: formData.remark,
        pocName: formData.PoCName,
        pocEmail: formData.PoCEmailID,
        pocMobile: formData.phoneNumber,
        referrerName: formData.referrerName,
        hearAboutUs: formData.hearAboutUs.value,
        hearOther: formData.hearAboutUs.value === 'Others' ? formData.hearOther : ''
      };
      await serviceProviderForm(serviceProviderFinalData).then((response) => {
        const { hasError } = response;
        if (hasError === false) {
          dispatch(reset('ServiceProviderForm'));
          setLogoImage([]);
          setFile([]);
          setProductGuides([]);
          setUploadResponses([]);
          navigate('/service-provider-master');
          dispatch(notifySet({ type: 'success', message: response.message }));
        } else if (hasError === true) {
          dispatch(notifySet({ type: 'error', message: response.message }));
        }
      });
    });
  };

  // add product guide
  const [openProductGuide, setOpenProductGuide] = useState(false);
  const productGuideUploadOptions = [
    { id: 1, label: 'File', value: 'file' },
    { id: 2, label: 'Link', value: 'link' }
  ];
  const [option, setOption] = useState(productGuideUploadOptions[0]);
  const [productGuides, setProductGuides] = useState([]);
  const [linkURL, setLinkURL] = useState('');

  const saveProductGuide = () => {
    const guide = {
      type: option.value,
      data: (option.value === 'file') ? file : linkURL,
      title: (option.value === 'file') ? file[0].name : linkURL
    };
    productGuides.push(guide);
    setProductGuides(productGuides);
    setOpenProductGuide(false);
    resetModal();
  };

  const resetModal = () => {
    setLinkURL('');
    setFile([]);
    setOption(productGuideUploadOptions[0]);
  };

  const cancelProductGuide = () => {
    setOpenProductGuide(false);
    resetModal();
  };

  return (
    <div className="container-fluid ">
      <div className="breadcrumb-menu-con">
        <Breadcrumbs
          separator=">"
          aria-label="breadcrumb"
        >
          <Link to="/service-provider-master">Service Partners</Link>
          <Link to="#">Add Service Partner</Link>
        </Breadcrumbs>
      </div>
      <h6>Add Service Partner</h6>
      <div className="row">
        <div className="col-sm-12">
          <ServiceProviderForm
            onButtonClick={onButtonClick}
            buttonSaveText="Submit Application"
            file={file}
            logoImage={logoImage}
            handleChangeLogo={handleChangeLogo}
            handleFileChange={handleFileChange}
            saveProductGuide={saveProductGuide}
            productGuideUploadOptions={productGuideUploadOptions}
            option={option}
            setOption={setOption}
            linkURL={linkURL}
            productGuides={productGuides}
            open={openProductGuide}
            setOpen={setOpenProductGuide}
            setLinkURL={setLinkURL}
            action="add"
            setProductGuides={setProductGuides}
            cancelProductGuide={cancelProductGuide}
          />
        </div>
      </div>
    </div>
  );
}

export default AddServiceProvider;
